import { EmailUser, User } from 'hydra-data-types';
import { LoadingAndErrorState } from '../LoadingAndErrorState';

type UserStatus = {
  /** true if the user has a tempPassword set by the system and is yet to set their own password. */
  setUserPassword: boolean | undefined;
  hasPaid: boolean;
  /** How the user authenticated on the Auth screen; set by LOGIN_USER / REGISTER_USER for nextScreenSelector. */
  authMethodUsed?: 'login' | 'register';
};

/** User details being collected but might not exist in firestore. */
export type IncompleteUser = {
  /** Type indicates the authentication method. email=firebase auth; partial = none (still collecting data) */
  type: 'partial';
  /** Only exists once the user has been created in Firebase. */
  userId?: string;
  /** Temporary randomly generated password. */
  tempPassword?: string;
} & Partial<Pick<EmailUser, 'name' | 'lastName' | 'email' | 'phoneNumber'>> &
  UserStatus;

export type CompletedUser = User & UserStatus;

export type AssessmentUser = IncompleteUser | CompletedUser;

export type UserState = AssessmentUser & LoadingAndErrorState;

export const INITIAL_USER_STATE: UserState = {
  type: 'partial',
  userId: undefined,
  name: undefined,
  lastName: undefined,
  email: undefined,
  tempPassword: undefined,
  phoneNumber: undefined,
  setUserPassword: undefined,
  hasPaid: false,
  loading: false,
  error: undefined,
};
